import { ScreenSize, MDSBreakpoints } from "@/mds/foundations";

export const MDSMediaQueries = {
  rules: Object.fromEntries(
    Object.entries(MDSBreakpoints).map(([mode, breakpoint]) => [
      mode as ScreenSize,
      `@media ${breakpoint}`,
    ])
  ) as Record<ScreenSize, string>,
  exclusion: {
    rules: Object.fromEntries(
      Object.entries(MDSBreakpoints).map(([mode, breakpoint]) => [
        mode as ScreenSize,
        `@media not all and ${breakpoint}`,
      ])
    ) as Record<ScreenSize, string>,
  },
} as const;

export type IMDSMediaQueries = typeof MDSMediaQueries;
